export default "__VITE_ASSET__bI7HINAP__"